"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// scripts
require("./props-filter");
exports.default = angular.module('rinca.core.filters', [
    'rinca.core.filters.props-filter',
]);



//////////////////
// WEBPACK FOOTER
// ./scripts/core/filters/index.ts
// module id = 319
// module chunks = 0